import React, { FC } from 'react'

//* styles
import {
  WebinarRecordingHeroContainer,
  WebinarRecordingInlineAuthor,
  WebinarRecordingSpeakersContainer,
} from '../style'

//* utils
import { ASSETS } from '../../../../../../constants/assets'
import { ModuleNames } from '../../../../../../constants/componentNames.constants'
import ImgUtil from '../../../../../../utils/img.utils'

//* components
import GlobalContainer from '../../../../../global/globalContainer'
import Hero from '../../../../../global/hero'
import Typography from '../../../../../global/typography'
import VideoSpotlight from '../../../../../global/videoSpotlight'
import WrapperImage from '../../../../../global/wrapperImage'

type SpeakersProps = {
  webinarRecordingData: any
  speakerText: string
}

type HeroSpotlightProps = {
  webinarRecordingData: any
  locale: string
  location: any
}

export const RenderSpeakers: FC<SpeakersProps> = ({ webinarRecordingData, speakerText }) => (
  <WebinarRecordingSpeakersContainer>
    <Typography className="WebinarRecordingSpeakers__title" type="labelAlt">
      {speakerText}
    </Typography>

    {webinarRecordingData.speakers.map((speaker: any) => {
      const imageSrc = speaker.headshot?.image?.file?.url || ''
      let byline

      if (speaker.__typename === ModuleNames.BIO) {
        const data = {
          headshot: {
            src: imageSrc ? ImgUtil.getResizedImageUrl(imageSrc, `width=250`) : '/',
            alt: speaker.headshot.altText || 'Headshot image',
          },
          firstName: speaker.firstName || '',
          lastName: speaker.lastName || '',
          fullName: speaker.firstName + ' ' + speaker.lastName,
          role: speaker.role || '',
          company: speaker.company || '',
        }

        if (data.role && data.company) {
          byline = `${data.role} at ${data.company}`
        } else if (data.role) {
          byline = data.role
        } else if (data.company) {
          byline = data.company
        }

        return (
          <WebinarRecordingInlineAuthor>
            <div className="InlineAuthor__Headshot-Img">
              <WrapperImage
                className="InlineAuthor__Headshot-Img-File"
                alt={data.headshot.alt}
                src={data.headshot.src}
                width={80}
                height={80}
                threshold={650}
              />
            </div>

            <div className="InlineAuthor__Information">
              <Typography className="WebinarRecording__InlineAuthor__Name" type="label">
                {data.fullName}
              </Typography>

              <Typography className="WebinarRecording__InlineAuthor__Byline" type="caption">
                {byline}
              </Typography>
            </div>
          </WebinarRecordingInlineAuthor>
        )
      }
    })}
  </WebinarRecordingSpeakersContainer>
)

export const RenderHeroSpotlight: FC<HeroSpotlightProps> = ({
  webinarRecordingData,
  locale,
  location,
}) => (
  <>
    <WebinarRecordingHeroContainer>
      <GlobalContainer>
        <Hero
          // @ts-ignore
          data={{
            headline: webinarRecordingData.title,
          }}
          location={location}
          pageTitle={webinarRecordingData.pageName}
          showBreadcrumbs={true}
          pageType="webinarRecording"
          locale={locale}
          breadcrumb={webinarRecordingData.breadcrumb}
        />

        <div className="WebinarRecording__clock_date_Container">
          <WrapperImage src={ASSETS.WHITE_CLOCK} height={22} width={22} threshold={650} />

          <Typography className="WebinarRecording__date" type="label">
            {webinarRecordingData.webinarDate}
          </Typography>
        </div>
      </GlobalContainer>
    </WebinarRecordingHeroContainer>

    {webinarRecordingData.spotlight && (
      <VideoSpotlight
        data={webinarRecordingData.spotlight}
        useCase={webinarRecordingData.spotlight?.useCase || ''}
      />
    )}
  </>
)
